import { useState } from 'react';

import { Button } from '@/components';
import { cn } from '@/lib/utils';

import { ANIMATION_PRESETS } from '../styleConstants';
import type { EntryAnimation } from '../styleTypes';

interface AnimationPickerProps {
  value: string | undefined;
  onChange: (value: EntryAnimation) => void;
}

export function AnimationPicker({ value, onChange }: AnimationPickerProps) {
  const [hoveredAnim, setHoveredAnim] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-3 gap-1.5">
      {ANIMATION_PRESETS.map((preset) => {
        const isActive = (value || 'none') === preset.value;
        const isHovered = hoveredAnim === preset.value;

        return (
          <Button
            key={preset.value}
            type="button"
            variant="ghost"
            onClick={() => onChange(preset.value as EntryAnimation)}
            onMouseEnter={() => setHoveredAnim(preset.value)}
            onMouseLeave={() => setHoveredAnim(null)}
            className={cn(
              'relative flex-col overflow-hidden rounded-lg border px-1 py-2 text-[10px] font-medium',
              isActive
                ? 'border-accent-500 bg-accent-50 dark:bg-accent-900/30 text-accent-600 dark:text-accent-400'
                : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-gray-300 dark:hover:border-gray-600',
            )}
          >
            {/* Animated preview dot */}
            {preset.value !== 'none' && (
              <div className="flex justify-center mb-1">
                <div
                  className={`w-3 h-3 rounded-full bg-accent-400 ${
                    isHovered ? `cp-anim-${preset.value}` : ''
                  }`}
                  style={isHovered ? { animationDuration: '800ms' } : {}}
                />
              </div>
            )}
            {preset.label}
          </Button>
        );
      })}
    </div>
  );
}
